import React from 'react';
import { useController } from 'react-hook-form';
import { Col, Flex, Body3Light } from '@/ui';
import { COLORS } from '@/utils/static';
import { Label } from '@/components';
import { Checkbox, Tooltip } from 'antd';
import { getLocalizedText } from '@/utils/helpers';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const defaultRowProps = { vertical: true };

export const CheckboxGroupForm = ({
  form,
  question,
  rowProps = defaultRowProps,
  disabled,
  required = false,
  isSelectScoringTooltip
}) => {
  const {
    field: { ref, ...field },
    fieldState: { error }
  } = useController({
    ...form,
    defaultValue: []
  });
  const { i18n } = useTranslation();
  const { value, onChange } = field;

  const onChangeField = (checked, id) => {
    let valueCopy = [...value];
    checked ? valueCopy.push(id) : (valueCopy = valueCopy.filter((item) => item !== id));

    onChange(valueCopy);
  };

  return (
    <div>
      {question.question && (
        <Label
          label={question.question}
          required={required}
          tooltip={question.tooltip ? getLocalizedText(question, 'tooltip', i18n) : null}
        >
          <Flex {...rowProps} $marginLeft={12}>
            {question?.availableAnswers &&
              question?.availableAnswers?.map((answer, key) => {
                if (isSelectScoringTooltip && answer.pointsScoring && answer.pointsScoring > 0) {
                  return (
                    <Tooltip title={`+${answer?.pointsScoring}`} placement='left' key={key}>
                      <Col $auto>
                        <StyledCheckbox
                          checked={value.includes(answer.id)}
                          onChange={(checked) => onChangeField(checked.target.checked, answer.id)}
                          disabled={disabled}
                        >
                          {answer.answer}
                        </StyledCheckbox>
                      </Col>
                    </Tooltip>
                  );
                } else if (isSelectScoringTooltip && answer?.points > 0) {
                  <Tooltip title={`+${answer?.points}`} placement='left' key={key}>
                    <Col $auto>
                      <StyledCheckbox
                        checked={value.includes(answer.id)}
                        onChange={(checked) => onChangeField(checked.target.checked, answer.id)}
                        disabled={disabled}
                      >
                        {answer.answer}
                      </StyledCheckbox>
                    </Col>
                  </Tooltip>;
                } else {
                  return (
                    <Col $auto key={key}>
                      <StyledCheckbox
                        checked={value.includes(answer.id)}
                        onChange={(checked) => onChangeField(checked.target.checked, answer.id)}
                        disabled={disabled}
                      >
                        {answer.answer}
                      </StyledCheckbox>
                    </Col>
                  );
                }
              })}
            {question?.productAvailableAnswers &&
              question?.productAvailableAnswers?.map((answer, key) => {
                return (
                  <Col $auto key={key}>
                    <StyledCheckbox
                      checked={value.includes(answer.id)}
                      onChange={(checked) => onChangeField(checked, answer.id)}
                      disabled={disabled}
                    >
                      {answer.answer}
                    </StyledCheckbox>
                  </Col>
                );
              })}
          </Flex>
        </Label>
      )}

      {error && (
        <Body3Light $color={COLORS.red} $marginTop={12}>
          {error.message}
        </Body3Light>
      )}
    </div>
  );
};

const StyledCheckbox = styled(Checkbox)`
  &&& {
    font-weight: 400 !important;
    margin-bottom: 5px;
  }
`;
